
function initWidget (data) {
    console.log('initWidget()-');
    this.settings = { ...data };
    this.env.appStore.widgetSettings = this.settings;
    this.env.appStore.oauthSessionId = null;

    console.log('initWidget() widgetSettings() -> : ', this.env.appStore.widgetSettings);
    console.log('initWidget() url: ', window.location);
}

export default initWidget;